// クライアントユーザー管理
import {setupCompanySuggestSelect} from '../../../common/suggests';

var baseDatepickerOpts = {
    locale: 'ja',
    dayViewHeaderFormat: 'YYYY年 M月',
    format: 'YYYY/MM/DD',
};

$(() => {
    // ユーザー一覧
    if ($('#client-users, #clients').length) {
        setupUsers();
    }
    if (document.getElementById('app-admin') != null) {
        $('.date .datepicker').datetimepicker(baseDatepickerOpts);
        $('input[name=corporateNumber_check]').on('change', function () {
            if ($(this).prop('checked')) {
                $('input[name=corporateNumber]').prop('disabled', false);
            } else {
                $('input[name=corporateNumber]').prop('disabled', true);
            }
        });
        $('input[name=plan_type_check]').on('change', function () {
            if ($(this).prop('checked')) {
                $('select[name=plan_type]').prop('disabled', false);
                $('input[name=service_start]').prop('disabled', false);
            } else {
                $('select[name=plan_type]').prop('disabled', true);
                $('input[name=service_start]').prop('disabled', true);
            }
        });
        $('input[name=default_contract_visibility_check]').on('change', function () {
            if ($(this).prop('checked')) {
                $('select[name=default_contract_visibility]').prop('disabled', false);
            } else {
                $('select[name=default_contract_visibility]').prop('disabled', true);
            }
        });
        $('input[name=service_start]').on('change', function () {
            compareDates($(this).val());
        }).on("change.datetimepicker", function(e){
            e.preventDefault();
            if (e.date) {
                compareDates($(this).val());
            }
        });

        $('.js-button').on('click', function () {
            if ($('input[name=corporateNumber_check]').prop('checked') || $('input[name=plan_type_check]').prop('checked')) {
                $('#admin_client_submission_modal').modal('show');
            } else {
                $(this).prop('disabled', true);
                $('#admin-client').submit();
            }
        });

        $('.modal-exec').on('click', function () {
            $('.js-button').prop('disabled', true);
            $('#admin-client').submit();
        });

        $('.js-send-invite-mail').on('click', function(e) {
            $('#admin-client-user-send-invite-mail_modal').modal('show');
        });
        $('.admin-user-send-invite-mail-exec').on('click', function(e) {
            $('#send_invite_mail').submit();
        });
        $('.js-send-entry-mail').on('click', function(e) {
            $('#admin-client-user-send-entry-mail_modal').modal('show');
        });
        $('.admin-user-send-entry-mail-exec').on('click', function(e) {
            $('#send_entry_mail').submit();
        });

        $('.js-send-entry-mail-radio').on('change', function(e) {
            chenge_send_mail_manual_button();
        });

    }
});

// ユーザー一覧
function setupUsers() {
    setupCompanySuggestSelect($('.js-select2'), "POST", "/api/users/findCompany", "client", function(data) {
        return {
            results: $.map(data, function (item) {
                return {
                    id: item.id,
                    text: item.company_name,
                    place: item.place
                }
            })
        }
    });
}


function compareDates(val) {
    if (val.length > 0) {
        const now = new Date();
        const date1 = new Date(val);
        const date2 = new Date(now.getFullYear() + '/' + (now.getMonth() + 1) + '/' + now.getDate());
        if (date1 < date2) {
            alert('反映日が本日以前ですがよろしいですか？')
        }
    }
}

function chenge_send_mail_manual_button() {
    var selectBox = document.getElementById('invite_cc_users_select');
    var check = document.getElementsByClassName('js-send-entry-mail-radio');
    if (check[0].checked) {
        selectBox.style.display = "block";
    } else if (check[1].checked) {
        selectBox.style.display = "none";
    } else {
        selectBox.style.display = "none";
    }
}
